import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// THEMES
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import { ToastContainer } from 'react-toastify';

// USER DEFINED
import Website from './Components/Website';
import { THEME_SETTINGS } from './themeSettings';
import { UtilityStyles } from './Styles/Utils';
import 'react-phone-input-2/lib/style.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Styles/AntDesignOverrides.css';
import store from './Redux/Store';

const theme = createTheme(THEME_SETTINGS);

/**
 * @component
 * @description The root component of the Devotee CMS application. It sets up essential application infrastructure including:
 * - Redux store for state management
 * - React Router for navigation
 * - Material-UI theming
 * - Toast notifications
 * - Global utility styles
 *
 * This component serves as the application shell and provides the necessary context providers
 * to all child components.
 *
 * @returns {JSX.Element} The fully configured application wrapper with all necessary providers
 *
 * @example
 * // In index.js
 * import App from './App';
 *
 * ReactDOM.render(
 *   <React.StrictMode>
 *     <App />
 *   </React.StrictMode>,
 *   document.getElementById('root')
 * );
 *
 * @since 1.0.0
 * @author BLUECOW Dev Team
 *
 * @see Website - Main content component
 * @see THEME_SETTINGS - Application theme configuration
 * @see UtilityStyles - Global utility styles
 */
function App() {
    return (
        <Provider store={store}>
            <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
                <MuiThemeProvider theme={theme}>
                    <Website />
                    <UtilityStyles />
                </MuiThemeProvider>
                <ToastContainer theme="colored" />
            </BrowserRouter>
        </Provider>
    );
}

export default App;
